import {
  ALL_CALLING_CODES,
  COUNTRY_CODE_MAP,
  PHONE_NUMBER_MASKS,
  FEATURE_TYPES,
} from "./Constants";
import copy from "copy-to-clipboard";

export const getUserData = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return userData;
};

export const uuidGenerator = () => {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
};

export const maskEmail = (email) => {
  const [localPart, domain] = email.split("@");

  // Determine the number of characters to show and hide in the local part
  const visibleChars = 2; // Number of characters to remain visible
  const hiddenChars = localPart.length - visibleChars; // Number of characters to hide

  // Generate the masked part
  const maskedPart = "*".repeat(hiddenChars > 0 ? hiddenChars : 0);

  // Concatenate the visible and masked parts
  const maskedEmail =
    localPart.substring(0, visibleChars) + maskedPart + "@" + domain;

  return maskedEmail;
};

export const formatBytes = (bytes) => {
  if (bytes < 1024) return `${bytes} Bytes`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(2)} KB`;
  const mb = kb / 1024;
  return `${mb.toFixed(2)} MB`;
};

export const downloadFile = (fileUrl, fileName = "") => {
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadFileAsBlob = async (fileUrl, fileName = "") => {
  try {
    const response = await fetch(fileUrl, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    // Infer the filename from the URL if not provided
    const urlSegments = fileUrl.split("/");
    const inferredFileName = fileName || urlSegments[urlSegments.length - 1];

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", inferredFileName);
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const formatOtpTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes < 10 ? `0${minutes}` : minutes}:${
    secs < 10 ? `0${secs}` : secs
  }`;
};

export const getCurrentPlanType = (reduxLoginData) => {
  const userData = reduxLoginData ? reduxLoginData : getUserData();
  if (userData) {
    return userData?.customer?.plan?.planType ?? "basic";
  }
  return "basic"; //basic,standard,pro,enterprise
};

export const isParsedTrue = (value) => {
  let isValid = false;
  try {
    isValid = JSON.parse(value);
  } catch (error) {
    isValid = false;
  }
  return isValid ? true : false;
};

export function isValidPhoneNumberWithCountryCode(number) {
  const pattern = /^(\+61\d{9,10}|\+64\d{7,10}|\+91\d{10}|\+1\d{10,14})$/;
  return pattern.test(number);
}

export function maskNoByCallingCode(calling_code) {
  switch (calling_code) {
    case "+61":
      return "_ ____ _____";
    case "+64":
      return "____ ___ ___";
    case "+353":
      return "(__) ___ ____";
    case "+1":
      return "___ ___ ____";
    case "+33":
      return "_ __ __ __ ____";
    case "+49":
      return "(____) ______";
    case "+39":
      return "(___) ___ ____";
    case "+351":
      return "___ ______";
    case "+43":
      return "___ ____ _____";
    case "+41":
      return "___ ___ ____";
    default:
      return "(___) ___ - ____";
  }
}
export function maskFullPhoneNoByCallingCode(phoneNumber = "") {
  if (phoneNumber.includes("+61")) {
    return "_ ____ _____";
  } else if (phoneNumber.includes("+64")) {
    return "____ ___ ___";
  } else if (phoneNumber.includes("+353")) {
    return "(__) ___ ____";
  } else if (phoneNumber.includes("+1")) {
    return "___ ___ ____";
  } else if (phoneNumber.includes("+49")) {
    return "(____) ______";
  } else if (phoneNumber.includes("+39")) {
    return "(___) ___ ____";
  } else if (phoneNumber.includes("+351")) {
    return "___ ___";
  } else if (phoneNumber.includes("+43")) {
    return "___ ____ _____";
  } else if (phoneNumber.includes("+41")) {
    return "___ ___ ____";
  }
  return "(___) ___ - ____";
}
export function getCountryCodeByFullPhone(phoneNumber = "") {
  const countryCode = ALL_CALLING_CODES.find((item) =>
    phoneNumber.includes(item)
  );
  return countryCode ? countryCode : "+61";
}

export function toObjectKey(str) {
  return str
    .normalize("NFD") // Normalize accented characters
    .replace(/[^\w\s]/g, "") // Remove special characters except spaces
    .trim() // Remove leading and trailing spaces
    .replace(/\s+/g, "_") // Replace spaces with underscores
    .replace(/_{2,}/g, "_") // Remove duplicate underscores
    .toLowerCase(); // Convert to lowercase for consistency
}

export function maskPhoneNumber(
  phoneNumber,
  countryCode,
  isWithCountryCode = true
) {
  const countryKey = COUNTRY_CODE_MAP[countryCode];
  if (!countryKey || !PHONE_NUMBER_MASKS[countryKey]) {
    return isWithCountryCode ? `${countryCode} ${phoneNumber}` : phoneNumber;
  }

  const mask = PHONE_NUMBER_MASKS[countryKey];
  let maskedNumber = "";
  let phoneIndex = 0;
  let maskIndex = 0;

  for (let char of mask) {
    if (char === ".") {
      maskedNumber += phoneNumber[phoneIndex] ?? "";
      phoneIndex++;
    } else {
      maskedNumber += char ?? "";
    }
    maskIndex++;
  }

  return isWithCountryCode ? `${countryCode} ${maskedNumber}` : maskedNumber;
}

export async function copyToClipboard(textToCopy) {
  copy(textToCopy);
}

export const formattedFeatureData = (featuresArray = []) => {
  const features = {};

  // Initialize all features as false
  Object.values(FEATURE_TYPES).forEach((featureName) => {
    features[featureName] = false;
  });

  if (featuresArray && Array.isArray(featuresArray)) {
    // Set available features to true
    featuresArray.forEach((feature) => {
      const featureName = FEATURE_TYPES[feature?.type];
      if (featureName) {
        features[featureName] = true;
      }
    });
  }
  return features;
};

export const getPlanIntervalLabel = (plan) => {
  let intervalLabel = "";
  if (plan?.isTrial) {
    intervalLabel = "Trial";
  } else if (!plan?.isExpiry) {
    intervalLabel = "No Expiry";
  } else if (plan?.interval) {
    let parsedInterval = parseInt(plan?.interval);
    if (isNaN(parsedInterval)) {
      intervalLabel = plan?.interval;
    } else if (parsedInterval == 30) {
      intervalLabel = "Monthly";
    } else if (parsedInterval == 365) {
      intervalLabel = "Annually";
    } else if (typeof parsedInterval === "number") {
      intervalLabel = `${parsedInterval} Days`;
    } else {
      intervalLabel = plan?.interval;
    }
  }
  return intervalLabel;
};

export const parseInteger = (value) => {
  const parsedValue = parseInt(value);
  return isNaN(parsedValue) || !parsedValue ? 0 : parsedValue;
};
